
import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
} from './types';
import {
    VisitTypeModal
} from './visittypesmodal';

/**
 * Redux action creator to set the list
 * of visit types
 * @param visittypesstate visit types information
 * @returns action instance
 */
export const setAction = (visittypesstate: VisitTypeModal[]):
    Action<typeof SET, VisitTypeModal[]> => ({
        type: SET,
        payload: visittypesstate,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * Alias for setAction to match epic naming
 */
export const setVisitTypesAction = setAction;

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction>;

